import { useFlag } from '@unleash/proxy-client-react'
import {
  getIsAdmin,
  getIsOwner,
  getPermissions,
  getTierName
} from '../react-query/authentication/query/use-me-query'
import { unleashFlags } from '../unleash-constants'

/**
 * Single source of truth for the organizational entries of the top navigation.
 * Both the menu items and the route guards read from here, so a view can never
 * be reachable by url while its icon is hidden.
 */
export const useOrganizationalAccess = () => {
  const permissions = getPermissions()
  const isAdmin = getIsAdmin()
  const isOwner = getIsOwner()
  const tierName = getTierName()
  const reportsEnabled = useFlag(unleashFlags.REPORTS)

  const isEnterprise = tierName?.toLowerCase() === 'enterprise'

  return {
    isResolved: !!permissions,
    canSeeUserManagement: !!permissions?.includes('ViewUsers') && isAdmin,
    canSeeReportTemplates:
      !!permissions?.includes('ViewReportTemplates') && reportsEnabled,
    canViewControlPanel: isOwner && isEnterprise
  }
}
